import useModuleTranslation from "../infra-no-ui/translation/useModuleTranslation.js";
import React from "react";

/**
 * Dynamically load translation files pertaining to the footer module.
 * @return {*}
 */
export default function useTranslationFooter() {

  // Imports must be memoized so that they don't change on every render
  const imports = React.useMemo(() => ({
    'en': import('./locales/en/footer.json'),
    'fr': import('./locales/fr/footer.json')
  }), []);

  return useModuleTranslation('footer', imports);
}
